<template>
  <div class="login login-admin vh-100 d-flex flex-column justify-content-center align-items-center bg-light">
    <div class="header p-3 position-absolute bg-white w-100 fixed-top">
      <h2 class="text-center">グローバルエステートサイト管理画面</h2>
    </div>
    <section class="wrapper">
      <div class="container-fluid">
          <div class="login-content d-flex flex-column justify-content-center align-items-centerr">
            <div class="inner-content">
              <b-form v-if="!status" class="w-100 bg-white p-4">
                <h1 class="text-center mb-4">パスワード再登録</h1>
                <div class="input-content">
                  <b-form-group label="新しいパスワード">
                    <b-form-input
                    id="new-pass"
                    type="password"
                    v-model="data.password"
                    required></b-form-input>
                  </b-form-group>

                  <b-form-group label="新しいパスワード（確認）">
                    <b-form-input
                    id="confirm-pass"
                    type="password"
                    required></b-form-input>
                  </b-form-group>
                </div>
                <div class="button-content text-center py-3">
                  <b-button @click="updatePassword" variant="primary mx-2" size="lg">パスワード再登録する</b-button>
                </div>
              </b-form>
              <div v-show="status" class="validation py-3 px-5 my-4">
                  <p class="m-0">{{ status }}</p>
              </div>
            </div>
          </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Home',
  data: function () {
    return {
      data: {
        email_address: null,
        password: null
      },
      status: null
    }
  },
  created () {
    this.setEmail()
  },
  computed: {
    ...mapState('forgetPassword', ['email', 'processState'])
  },
  methods: {
    ...mapActions('forgetPassword', ['resetPassword']),
    setEmail: function () {
      this.data.email_address = this.email
    },
    updatePassword: function () {
      this.resetPassword(this.data)
    }
  },
  watch: {
    processState: function () {
      this.status = 'パスワード再登録完了。 新しいパスワードにて再度ログインをお願いいたします。'
      setTimeout(() => { this.$router.push({ name: 'Login' }) }, 5000)
    },
    errors: function () {
    }
  }
}
</script>
